import React, { useState, useEffect } from "react";
import dayjs from "dayjs";

export const DateTime = () => {
  var [date, setDate] = useState(new Date());

  useEffect(() => {
    var timer = setInterval(() => setDate(new Date()), 1000);
    return function cleanup() {
      clearInterval(timer);
    };
  });

  return (
    <div>
      <h2 className="text-6xl mb-5 clock"> {dayjs(date).format("HH:mm")}</h2>
    </div>
  );
};

export default DateTime;